import {
  HIDE_BOTTOM_NAV,
  HIDE_TOP_NAV,
  SHOW_BOTTOM_NAV,
  SHOW_TOP_NAV,
} from "../Actions/types";

const initialState = {
  showTopNav: true,
  showBottomNav: true,
};

const mobileNavReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOP_NAV:
      return { ...state, showTopNav: true };
    case HIDE_TOP_NAV:
      return { ...state, showTopNav: false };
    case SHOW_BOTTOM_NAV:
      return { ...state, showBottomNav: true };
    case HIDE_BOTTOM_NAV:
      return { ...state, showBottomNav: false };
    default:
      return state;
  }
};

export default mobileNavReducer;
